export enum SelectDialogMode {
    STANDARD = 'STANDARD',
    DATEPICKER = 'DATEPICKER',
}
